"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainReportSortColumn = void 0;
var TrainReportSortColumn;
(function (TrainReportSortColumn) {
    TrainReportSortColumn["Name"] = "Name";
    TrainReportSortColumn["Date"] = "Date";
    TrainReportSortColumn["TemplateName"] = "TemplateName";
})(TrainReportSortColumn || (exports.TrainReportSortColumn = TrainReportSortColumn = {}));
//# sourceMappingURL=sort.js.map